import {Grid, Radio, Slot, Text, Trail, Typography} from '@logistics-frontend/blocks'
import {Surge} from '@yandex-delivery/form'
import React, {memo} from 'react'

import {appConfig} from 'src/shared/config'
import {formatOfferInterval, formatPrice} from 'src/shared/utils'

import {NoOffersPlaceholder} from '../NoOffersPlaceholder/NoOffersPlaceholder'
import * as classes from './OfferList.classes'
import {useOfferList} from './OfferList.hooks'

type Props = {
  isValid?: boolean
}

export const OfferList = memo<Props>(function OfferList({isValid = true}) {
  const {errorMessage, isOffersPending, value, offers, changeHandler} = useOfferList()
  
  if (offers && offers.length > 0) {
    return (
      <>
        {offers.map(offer => (
          <Slot
            key={offer.id || offer.tariff}
            className={!!offer.disableReason ? classes.disabled : undefined}
            size="l"
          >
            <Text className={classes.body}>
              <Typography thickness="medium" variant="body2">
                {offer.title}
              </Typography>
              <Typography className={isOffersPending ? classes.skeleton : undefined} color="minor" variant="caption1">
                {offer.disableReason
                  ? offer.disableReason
                  : formatOfferInterval(offer.tariff, offer.visitingIntervals).full}
              </Typography>
            </Text>
            {offer.surgeRatio > 1 && (
              <Trail ml="s">
                <Surge ratio={offer.surgeRatio} />
              </Trail>
            )}
            <Trail ml="s">
              <Grid alignItems="flex-end" direction="column" size="xs" container>
                <Typography
                  className={isOffersPending ? classes.skeleton : undefined}
                  Component={Grid}
                  thickness="medium"
                  variant="body2"
                  xs={12}
                  item
                >
                  {formatPrice(offer.price, {
                    currencySign: appConfig.currencySign,
                    currency: appConfig.currency,
                    country: appConfig.countryCode,
                  })}
                </Typography>
              </Grid>
            </Trail>
            <Trail ml="s">
              <Radio
                checked={value && value.tariff === offer.tariff}
                data-e2e={`tariff-${offer.tariff}`}
                disabled={!!offer.disableReason}
                error={errorMessage}
                onChange={changeHandler(offer)}
              />
            </Trail>
          </Slot>
        ))}
      </>
    )
  }

  return <NoOffersPlaceholder isPending={isOffersPending} isValid={isValid} />
})
